export default "__VITE_ASSET__GlVMvN9g__"